<script>

import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";
import router from "@/router";

export default {
  name: "SplashPage",
  setup() {

    let store = useStore()
    let uid = localStorage.getItem('uid')

    let version = '1.0.3'

    function check_version() {
      FreeWorld.Heisenberg({action:'info'} , 'info').then((res)=>{

        if (res.data.upadting == 1){
          Swals.Updating()
        }else if (version !== res.data.version){
          Swals.NewVersion()
        }else{
          store.commit('set_info', res.data)
          if (uid) {
            run_app()
          } else {
            router.push({name: 'LoginPage'})
          }
        }

      }).catch((res) => {
        Swals.Catch(res, check_version, true)
      })

    }
    check_version()

    function run_app() {

      FreeWorld.Heisenberg({action: 'addresses'}, 'info', true).then((res) => {

        store.commit('set_address', res.data)

        FreeWorld.Heisenberg({action: 'cards'}, 'info', true).then((res) => {

          store.commit('set_Card', res.data.cards)

          FreeWorld.Heisenberg({action: 'profile'}, 'info', true).then((res) => {

            store.commit('set_profile', res.data)

              router.push({name: 'HomePage'})

          }).catch((res) => {
            Swals.Catch(res, run_app, true)
          })

        }).catch((res) => {
          Swals.Catch(res, run_app, true)
        })

      }).catch((res) => {
        Swals.Catch(res, run_app, true)
      })

    }


    return {}

  }

}
</script>


<template>

  <div id="main" class="bg-color d-flex flex-column align-items-center justify-content-center">

    <img class="img_logo" src="../assets/img/logo.png" alt="">

    <br>
    <br>
    <br>

    <div class="waviy">

      <span class="text-white" style="--i:1">A</span>
      <span class="text-white" style="--i:2">P</span>
      <span class="text-white" style="--i:3">P</span>
      <span class="text-white" style="--i:4">M</span>
      <span class="text-white" style="--i:5">A</span>
      <span class="text-white" style="--i:6">R</span>
      <span class="text-white" style="--i:7">K</span>
      <span class="text-white" style="--i:8">E</span>
      <span class="text-white" style="--i:9">T</span>
      <span class="text-white" style="--i:10">.</span>
      <span class="text-white" style="--i:11">.</span>
      <span class="text-white" style="--i:12">.</span>

    </div>

  </div>


</template>


<style scoped>

.img_logo {
  height: 300px;
}

.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, .2));
  display: flex;
  flex-direction: row-reverse;
}

.waviy span {
  font-family: logo;
  position: relative;
  display: inline-block;
  font-size: 30px;
  color: #fff;
  text-transform: uppercase;
  animation: waviy 1s infinite;
  animation-delay: calc(.1s * var(--i));
}

@keyframes waviy {
  0%, 40%, 100% {
    transform: translateY(0)
  }
  20% {
    transform: translateY(-20px)
  }
}

</style>